/**
 * Implement Gatsby's Browser APIs.
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */
const { wrapRootElement } = require("./libs/gatsby")

exports.wrapRootElement = wrapRootElement

// Disable Gatsby's history and back button features
exports.shouldUpdateScroll = () => false
exports.onRouteUpdate = () => {
  // Disable Gatsby's scroll restoration
  if (window.history.scrollRestoration) {
    window.history.scrollRestoration = 'auto'
  }
}

// Override Gatsby's navigation to use browser's default behavior
exports.onPreRouteUpdate = () => {
  // Disable Gatsby's navigation handling
  window.___navigate = (to) => {
    window.location.href = to
  }
}

// exports.onPreRouteUpdate = onPreRouteUpdate
// exports.onRouteUpdate = onRouteUpdate
// exports.wrapPageElement = wrapPageElement
// exports.onInitialClientRender = onInitialClientRender
// exports.onClientEntry = onClientEntry
